import { composeGuards, redirectIfUnauthorized } from '@/app/shared/utils/router-guards/auth';
import { redirectWithMainEventScope } from '@/app/shared/utils/router-guards/mainEvent';

const BASE_PATH = '/bookings';

export const guestOperationsBookingsRoutes = [
    {
        name: 'BookingsGuestOperationsMainEventsList',
        path: BASE_PATH,
        component: () =>
            import('@/app/modules/bookings/guestOperations/MainEventsList/MainEventsList.vue'),
        props: true,
        beforeEnter: composeGuards(
            redirectIfUnauthorized(
                (permissions) => permissions.bookings.guestOperations.mainEventsList
            ),
            redirectWithMainEventScope((mainEventId) => ({
                name: 'BookingsGuestOperationsMainEventParticipantsList',
                params: { mainEventId },
            }))
        ),
    },
    {
        name: 'BookingsGuestOperationsMainEventsFullList',
        path: `${BASE_PATH}/full-list`,
        component: () =>
            import(
                '@/app/modules/bookings/guestOperations/MainEventsFullList/MainEventsFullList.vue'
            ),
        props: true,
        beforeEnter: redirectIfUnauthorized(
            (permissions) => permissions.bookings.guestOperations.mainEventsList
        ),
    },
    {
        name: 'BookingsGuestOperationsMainEventParticipantsList',
        path: `${BASE_PATH}/main-events/:mainEventId/participants`,
        component: () =>
            import(
                '@/app/modules/bookings/guestOperations/MainEventParticipantsList/MainEventParticipantsList.vue'
            ),
        props: true,
        beforeEnter: redirectIfUnauthorized(
            (permissions) => permissions.bookings.guestOperations.mainEventParticipantsList
        ),
    },
    {
        name: 'BookingsGuestOperationsMainEventAddParticipant',
        path: `${BASE_PATH}/main-events/:mainEventId/participants/add`,
        component: () =>
            import(
                '@/app/modules/bookings/guestOperations/MainEventParticipantsList/MainEventParticipantsList.vue'
            ),
        props: true,
        beforeEnter: redirectIfUnauthorized(
            (permissions) => permissions.bookings.guestOperations.addMainEventParticipant
        ),
    },
    {
        name: 'BookingsGuestOperationsMainEventParticipantDuplicatesList',
        path: `${BASE_PATH}/main-events/:mainEventId/participant-duplicates`,
        component: () =>
            import(
                '@/app/modules/bookings/guestOperations/MainEventParticipantDuplicates/MainEventParticipantDuplicates.vue'
            ),
        props: true,
        beforeEnter: redirectIfUnauthorized(
            (permissions) => permissions.bookings.guestOperations.mainEventParticipantsList
        ),
    },
];
